export const coproApprovalStatuses = ['REQUIRED', 'NOT_REQUIRED', 'OBTAINED'] as const
export type CoproApprovalStatus = (typeof coproApprovalStatuses)[number]

export const coproApprovalStatusLabel: Record<CoproApprovalStatus, string> = {
  REQUIRED: 'Nécessaire',
  NOT_REQUIRED: 'Pas nécessaire',
  OBTAINED: 'Obtenu',
}
